// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__mcKVO","burgerOpen":"burgerOpen__CQxHH","burgerClose":"burgerClose__39oqG","light":"light__tjzwU","dark":"dark__fB0j8"};